import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { BsChatDots } from 'react-icons/bs';

interface ConsultationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: {
    waktu: 'sekarang' | 'jadwal';
    layanan: string;
  }) => void;
  isOnline: boolean;
}

const Service: React.FC<ConsultationModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  isOnline
}) => {
  const [waktu, setWaktu] = useState<'sekarang' | 'jadwal'>('sekarang');
  const [layanan, setLayanan] = useState('Chat dengan Dokter');

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-xl p-6 w-full max-w-sm shadow-lg relative">
        <button
          className="absolute top-3 right-3 text-gray-500"
          onClick={onClose}
        >
          <FaTimes />
        </button>

        <h3 className="text-lg font-semibold text-center mb-4">Pilih Layanan</h3>

        {/* Pilih waktu konsultasi */}
        <div className="mb-4">
          <h4 className="font-semibold mb-1">Waktu Konsultasi</h4>
          <p className="text-sm text-gray-500 mb-2">
            Silahkan Pilih Waktu Konsultasi yang Anda butuhkan
          </p>

          <div className="space-y-2">
             {isOnline && (
              <label className="flex items-center gap-3 p-2 border rounded-lg cursor-pointer">
                <input
                  type="radio"
                  value="sekarang"
                  checked={waktu === 'sekarang'}
                  onChange={() => setWaktu('sekarang')}
                />
                <div>
                  <p className="font-medium">Konsultasi Sekarang</p>
                  <p className="text-xs text-gray-500">Mulai konsultasi sekarang</p>
                </div>
              </label>
            )}          

            {/* <label className="flex items-center gap-3 p-2 border rounded-lg cursor-pointer">
              <input
                type="radio"
                value="jadwal"
                checked={waktu === 'jadwal'}
                onChange={() => setWaktu('jadwal')}
              />
              <div>
                <p className="font-medium">Jadwalkan Konsultasi</p>
                <p className="text-xs text-gray-500">Pilih waktu</p>
              </div>
            </label> */}
          </div>
        </div>

        <button
          className="w-full bg-morning-300 text-white py-2 rounded-full font-semibold"
          onClick={() => onSubmit({ waktu, layanan })}
        >
          Ok
        </button>
      </div>
    </div>
  );
};

export default Service;
